export default {
  image: 'WA-MIWO-024.png',
  pdf: 'Wandaufbau-mit-Mineralwolle-24-WA-MIWO-024-Rev.02.pdf',
  productData: {
    serialNumber: 'WA-MIWO-024',
    technicalValues: {
      soundReductionIndex: {
        output: '59,6',
        value: 59.6
      },
      heatTransferCoefficient: {
        output: '0,14',
        value: 0.14
      },
      fireBehavior: {
        output: 'schwerentflammbar (B1)',
        value: 'B1'
      },
      fireResistanceOuter: {
        output: 'F 90-B / K\u208260' ,
        value: 'F-90-B-K260'
      },
      fireResistanceInner: {
        output: 'F 90-B / K\u208260' ,
        value: 'F-90-B-K260'
      }
    },
    name: 'Wandaufbau mit Mineralwolle l Aufbau 24',
    construction: {
      composition: [
        {
          output: 'organischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'org-1'
        },
        {
          output: 'Sto-Steinwolleplatte 2/B/H4 W5',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'mst-100'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-12'
        },
        {
          output: '60/180',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-160'
        },
        {
          output: '160 mm Steinwolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cirw-160'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'if-12'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'io-12'
        }, 
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: 'ig3-12'
        }
      ],
      sum: {
        output: '297,5',
        value: 297.5
      }
    }
  }
}
